import React, { useState } from 'react';

import { TextButton } from '@components/Button/variants';
import { useAppContext } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, ContentType, click } from '@tracking';

import SignUpModal from '../SignUpModal';
import NewsletterActionButton from './NewsletterActionButton';
import {
  FEATURES,
  NewsletterActionProps,
  PERSONALIZED_BRIEFING,
  READ_THE_LATEST,
} from './interfaces';

const NewsletterAction = ({
  accessLevel,
  afterSignUpUrl,
  currentUserSubscribed,
  description,
  hasPublishedArticles,
  id,
  isPro,
  isSubscriberOnly,
  name,
  offers,
  readLatestPath,
  updateNewsletterSubscription,
}: NewsletterActionProps) => {
  const { trackEvent } = useEventTracking({
    contentType: ContentType.Newsletter,
    contentId: id,
  });
  const { initialCurrentUser } = useAppContext();
  const [showModal, setShowModal] = useState(false);
  const isPersonalizedBriefing = name.includes(PERSONALIZED_BRIEFING);
  const isComingSoon = readLatestPath.includes(FEATURES) && !hasPublishedArticles;

  const canSubscribeToNewsletter =
    initialCurrentUser?.access_level >= accessLevel || !isSubscriberOnly;

  const toggleModal = () => setShowModal((prev) => !prev);

  const clickTarget = (clickTarget: ClickTarget, label: string) => {
    trackEvent(click({ clickTarget: clickTarget, clickText: label }));
  };

  return (
    <div className="flex items-center justify-between">
      <NewsletterActionButton
        newsletterName={name}
        canSubscribeToNewsletter={canSubscribeToNewsletter}
        currentUserSubscribed={currentUserSubscribed}
        initialCurrentUser={initialCurrentUser}
        onClickCapture={clickTarget}
        toggleModal={toggleModal}
        isPro={isPro}
        isPersonalizedBriefing={isPersonalizedBriefing}
        id={id}
        afterSignUpUrl={afterSignUpUrl}
        offers={offers}
        isCurrentlySubscriber={initialCurrentUser?.is_subscriber}
        isProSubscriber={initialCurrentUser?.is_pro_subscriber}
        updateStateHandlerOnSubscribe={() => updateNewsletterSubscription(id, true)}
        updateStateHandlerOnUnsubscribe={() => updateNewsletterSubscription(id, false)}
      />
      {!isPersonalizedBriefing &&
        (isComingSoon ? (
          <span className="font-suisse-screen text-disclosure-sm">Coming soon</span>
        ) : (
          <TextButton
            as="link"
            href={readLatestPath}
            className="!w-auto font-suisse-screen text-disclosure-sm"
            onClickCapture={() =>
              trackEvent(
                click({ clickTarget: ClickTarget.NewsletterCard, clickText: READ_THE_LATEST })
              )
            }
          >
            Read the latest
          </TextButton>
        ))}

      {showModal && (
        <SignUpModal
          newsletterIds={[Number(id)]}
          description={description}
          headline={`Subscribe to ${name} Newsletter`}
          name={name}
          onClose={toggleModal}
        />
      )}
    </div>
  );
};
export default NewsletterAction;
